import { axiosInstance } from "@/axios/interceptors";
import { CountryListSchema } from "@/features/countries/schema";
import { ZodSentryReporter } from "@/lib/zod-sentry-reporter";

export async function getCountries() {
	const response = await axiosInstance.get("/global/countries");
	return ZodSentryReporter.parse(CountryListSchema, response);
}
